module.exports = __webpack_public_path__ + "assets/img/about2.1dc16db4.jpg";